import Builder from './Builder';

export default class Keyword extends Builder {}


